
import React, { Component } from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import ReactGA from 'react-ga';
import i18next from 'i18next';

import './App.css';
import PersonList from './components/PersonList';
import SignInScreen from './components/SignInScreen';
import PersonFocus from './components/PersonFocus';
import RecycleBin from './components/RecycleBin';
import ShareReceive from './components/ShareReceive';

import getGATrackingID from './helpers/getGATrackingID'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: null,
            toNamedUser: false,
        };
    }

    userHasAuthenticated = authenticated => {
        this.setState({ 
            isAuthenticated: authenticated            
         });
    }

    doToNamedUser = (toNamedUser) => {
        this.setState({toNamedUser: toNamedUser});
    }

    componentDidMount(){
        document.body.dir = i18next.dir()
    }

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            toNamedUser: this.state.toNamedUser,
            doToNamedUser: this.doToNamedUser
        };

        if (!this.state.isAuthenticated || (firebase.auth().currentUser.isAnonymous && this.state.toNamedUser)){
            return(
                <div className="Sign-In-Screen">
                    <SignInScreen childProps={childProps}/>
                </div>
            );
        }

        ReactGA.initialize(getGATrackingID());
        ReactGA.pageview(window.location.pathname + window.location.search);
        
        return (
            <div className="App">
                <Switch>
                    <Route exact path="/" render={(props) => <PersonList childProps={childProps} {...props} />} />
                    <Route exact path="/personfocus/:id" component={PersonFocus} />
                    <Route exact path="/recyclebin" component={RecycleBin} />
                    <Route exact path="/sharereceive/:id" component={ShareReceive} />
                    <Redirect to="/" />
                </Switch>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js